// ? These components function with alpine + tailwind UI components
// import Swiper, {Navigation, Pagination, Mousewheel, EffectCreative, Autoplay, FreeMode} from 'swiper'
import Swiper from 'swiper'
import {Autoplay, EffectCreative, FreeMode, Mousewheel, Navigation, Pagination} from 'swiper/modules'
import PhotoSwipeLightbox from "photoswipe/lightbox"
import 'photoswipe/style.css'
import PhotoSwipeDynamicCaption from "photoswipe-dynamic-caption-plugin"
import {Loader} from '@googlemaps/js-api-loader'
import flatpickr from "flatpickr"

window.obaia.Components = {}
window.obaia.Components.datePicker = (options = {}) => {
    return {
        // value: ['2022/01/01', '2022/01/10'],
        selectedData: options.selectedData ?? '',
        init() {
            // For year-only input, we'll use a simple input field instead of flatpickr
            // Just set the value if provided
            if (this.selectedData) {
                this.$refs.picker.value = this.selectedData;
            }

            // Add event listener to ensure only numbers are entered
            this.$refs.picker.addEventListener('input', function(e) {
                // Remove any non-digit characters
                this.value = this.value.replace(/\D/g, '');

                // Limit to 4 digits (year)
                if (this.value.length > 4) {
                    this.value = this.value.slice(0, 4);
                }
            });

            /* Original flatpickr implementation
            let picker = flatpickr(this.$refs.picker, {
                // mode: '',
                dateFormat: 'Y',
                defaultDate: this.selectedData,
                // onChange: (date, dateString) => {
                //     this.value = dateString.split(' to ')
                // }
            })
            */

            // this.$watch('value', () => picker.setDate(this.value))
        }
    }
}
window.obaia.Components.marquee = () => {
    let animationFrameId = null
    let shouldAnimate = false
    const throttleDelay = 33 // Throttle delay (approximately 33 = 30FPS, 16 = 60FPS)

    return {
        posX: 0,
        marqueeSpeed: 200, // Speed of the marquee (pixels per second)
        marqueeElement: null,
        marqueeWidth: 0,
        contentWidth: 0,
        clone: null,
        cloneCount: 0,
        logoItem: null,
        logoWidth: null,

        init() {
            this.marqueeElement = this.$refs.marquee
            this.marqueeWidth = this.marqueeElement.offsetWidth
            this.contentWidth = this.marqueeElement.scrollWidth

            this.logoItem = this.marqueeElement.querySelector('.js-logo-item')
            this.logoWidth = this.logoItem.offsetWidth
            // Wait for DOMContentLoaded event
            // Call handleResize initially to set up the marquee
            // document.addEventListener('DOMContentLoaded', () => console.log('DOC LOADED'))
            this.handleResize()
        },

        startAnimation() {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId)
            }

            const animate = () => {
                // this.moveMarquee()
                let isAnimating = false

                function throttle(callback, delay) {
                    let timeoutId = null

                    return function () {
                        if (!isAnimating) {
                            isAnimating = true
                            callback.apply(this, arguments)

                            timeoutId = setTimeout(() => {
                                isAnimating = false
                            }, delay)
                        }
                    }
                }

                // Wrap the moveMarquee function with the throttle function
                const throttledMoveMarquee = throttle(this.moveMarquee.bind(this), throttleDelay) // Adjust the delay as needed (e.g., 16ms for approximately 60 FPS)

                // Call the throttledMoveMarquee function instead of moveMarquee in the animation loop
                throttledMoveMarquee()

                animationFrameId = requestAnimationFrame(animate)
            }

            animationFrameId = requestAnimationFrame(animate)
        },

        stopAnimation() {
            cancelAnimationFrame(animationFrameId)
        },

        moveMarquee() {
            this.posX -= this.marqueeSpeed / 100

            if (this.posX < -this.contentWidth) {
                this.posX += this.contentWidth
            }

            this.marqueeElement.style.transform = `translate3d(${this.posX}px,0,0)`
        },

        handleResize() {
            const viewportWidth = window.innerWidth
            const shouldAnimateNew =
                this.contentWidth > this.marqueeWidth || this.contentWidth > viewportWidth

            if (shouldAnimateNew && !shouldAnimate) {
                // Start animation
                this.startAnimation()
                shouldAnimate = true

                // Remove existing clones
                this.removeClones()

                // Recreate clones based on the updated marquee width
                // const logoItem = this.marqueeElement.querySelector('.js-logo-item')
                // const logoWidth = logoItem.offsetWidth
                const clonesNeeded = Math.ceil(this.marqueeWidth / this.logoWidth) + 1

                this.cloneCount = clonesNeeded

                this.clone = this.marqueeElement.cloneNode(true)
                for (let i = 0; i < clonesNeeded; i++) {
                    if (this.marqueeElement.children[i]) {
                        this.clone.appendChild(this.marqueeElement.children[i].cloneNode(true))
                    }
                }

                this.marqueeElement.appendChild(this.clone)
            } else if (!shouldAnimateNew && shouldAnimate) {
                // Stop animation
                this.stopAnimation()
                shouldAnimate = false

                // Remove existing clones
                this.removeClones()
            }
        },

        removeClones() {
            this.marqueeElement.style.transform = 'translate3d(0px,0,0)'
            this.posX = 0
            if (this.clone) {
                this.marqueeElement.removeChild(this.clone)
                this.clone = null
                this.cloneCount = 0
            }
        }
    }
}

window.obaia.Components.typingText = function (options = {}) {
    return {
        text: options.text ?? '',
        textArray: options.textArray ?? [],
        textIndex: options.textIndex ?? 0,
        charIndex: options.charIndex ?? 0,
        pauseEnd: options.pauseEnd ?? 1500,
        cursorSpeed: options.cursorSpeed ?? 420,
        pauseStart: options.pauseStart ?? 20,
        typeSpeed: options.typeSpeed ?? 110,
        direction: 'forward',
        typingInterval: null,
        init() {
            const cursor = this.$refs.cursor
            if (cursor) {
                setInterval(() => {
                    if (cursor.classList.contains('hidden')) {
                        cursor.classList.remove('hidden')
                    } else {
                        cursor.classList.add('hidden')
                    }
                }, this.cursorSpeed);
            }
            this.typingInterval = setInterval(() => this.startTyping(), this.typeSpeed)
        },
        startTyping() {
            let current = this.textArray[this.textIndex]
            if (this.charIndex > current.length) {
                this.direction = 'backward'
                clearInterval(this.typingInterval)
                setTimeout(() => {
                    this.typingInterval = setInterval(() => this.startTyping(), this.typeSpeed);
                }, this.pauseEnd);
            }
            this.text = current.substring(0, this.charIndex)
            if (this.direction === 'forward') {
                this.charIndex += 1;
            } else {
                if (this.charIndex === 0) {
                    this.direction = 'forward'
                    clearInterval(this.typingInterval)
                    setTimeout(() => {
                        this.textIndex += 1;
                        if (this.textIndex >= this.textArray.length) {
                            this.textIndex = 0;
                        }
                        this.typingInterval = setInterval(() => this.startTyping(), this.typeSpeed);
                    }, this.pauseStart);
                }
                this.charIndex -= 1;
            }
        }
    }
}
window.obaia.Components.maps = function (options = {}) {
    let markers = []
    return {
        map: null,
        markerFeed: options.markerFeed ?? [],
        init() {
            const loader = new Loader({
                apiKey: window.obaia.api.googleMaps,
                version: "weekly",
                libraries: ["places", "geometry"]
            })
            const mapOptions = {
                center: {
                    lat: 52.3754,
                    lng: 7.0062,
                },
                zoom: 16,
                zoomControl: true,
                disableDefaultUI: true,
            }
            loader.load().then((google) => {
                // this.locations = window.obaia.Markers
                this.map = new google.maps.Map(document.getElementById("js-maps"), mapOptions)
                const bounds = new google.maps.LatLngBounds()


                let infowindow = new google.maps.InfoWindow();


                // Render the markers on the map
                for (let i = 0; i < this.markerFeed.length; i++) {
                    const marker = new google.maps.Marker({
                        position: new google.maps.LatLng(this.markerFeed[i][0], this.markerFeed[i][1]),
                        map: this.map,
                        icon: '/assets/img/base/marker.svg',
                        // icon: this.markerFeed[i][3] ? this.markerIcons.gents.default : this.markerIcons.gals.default,
                        // zIndex: 999,
                        markerId: this.markerFeed[i][2],
                    })
                    bounds.extend(marker.getPosition())
                    google.maps.event.addListener(marker, 'click', () => {

                        // const infowindow = new google.maps.InfoWindow({
                        //     content: contentString,
                        //     ariaLabel: this.markerFeed[i][3],
                        // });

                        // infowindow
                        const contentString =
                            '<div id="content">' +
                            "<img class='h-full object-cover w-[320px]' width='320' height='320' src=" + this.markerFeed[i][4] + " alt=" + this.markerFeed[i][3] + ">" +
                            '<h2 class="font-serif text-2xl mt-4">' +
                            this.markerFeed[i][3] +
                            "</h2>" +
                            "<p class='text-base mt-4 font-bold'>" +
                            this.markerFeed[i][5]['adres'] + " " + this.markerFeed[i][5]['number'] +
                            "<br>" + this.markerFeed[i][5]['postcode'] +
                            "</p>" +
                            "</div>";
                        infowindow.setContent(contentString)
                        infowindow.close()
                        infowindow.open({
                            anchor: marker,
                            map: this.map,
                        });
                    })
                    markers.push(marker)
                }
                // this.map.fitBounds(bounds)
            }).catch(e => {
                // do something
            })
        },
    }
}
window.obaia.Components.gallery = () => {
    return {
        loadMore: false,
        init() {
            const lightbox = new PhotoSwipeLightbox({
                gallery: this.$el,
                // children: 'a',
                children: '.js-slide',
                pswpModule: () => import('photoswipe')
            })
            const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
                // Plugins options, for example:
                type: 'mobile',
                horizontalEdgeThreshold: 0,
                mobileCaptionOverlapRatio: 0,
                verticallyCenterImage: true
            });
            lightbox.init()
        }
    }
}
window.obaia.Components.swiper = (options) => {
    return {
        swiperConstance: '',
        init() {
            let initialSlideIndex = 0
            if (options.initialSlide !== '' && typeof options.initialSlide === 'string') {
                initialSlideIndex = Array.prototype.indexOf.call(this.$el.querySelectorAll('.swiper-slide'), this.$el.querySelector('#' + options.initialSlide))
            }
            const thisElem = this.$el
            const thisAlpine = this
            // window.addEventListener('load', () => {
            this.swiperConstance = new Swiper(thisElem, {
                modules: [Navigation, Pagination, Mousewheel, EffectCreative, Autoplay, FreeMode],
                autoplay: options.autoplay ?? false,
                speed: options.speed ?? 300,
                freeMode: options.freeMode ?? false,
                // cssMode: options.cssMode ?? false,
                grabCursor: options.grabCursor ?? false,
                loop: options.loop ?? false,
                autoHeight: options.autoHeight ?? false,
                slidesPerView: options.slidesPerView ?? 1,
                centeredSlides: options.centeredSlides ?? false,
                spaceBetween: options.spaceBetween ?? 16,
                initialSlide: options.initialSlide ? initialSlideIndex : options.centeredSlides ? this.$el.querySelectorAll('.swiper-slide').length / 2 : 0,
                mousewheel: {
                    forceToAxis: true,
                },
                navigation: {
                    prevEl: this.$refs.swiperPrev ?? thisElem.closest('section').querySelector('.js-swiper-button-prev'),
                    nextEl: this.$refs.swiperNext ?? thisElem.closest('section').querySelector('.js-swiper-button-next'),
                },
                pagination: options.pagination ? {
                    el: thisElem.closest('section').querySelector('.js-swiper-pagination'),
                    clickable: true,
                    renderBullet: function (index, className) {
                        let names = []
                        thisElem.querySelectorAll('.swiper-slide').forEach((slide) => {
                            names.push(slide.getAttribute('data-name'))
                        })
                        return '<li class="cursor-pointer antialiased ' + className + '">' + names[index] + '</li>';
                    }
                } : {},
                breakpoints: {
                    ...options.breakpoints
                },
                on: {
                    slideChange: function (sw) {
                        if (options.showCount) {
                            thisAlpine.$refs.current.innerHTML = (sw.activeIndex + 1)
                        }
                    },
                    init: function (sw) {
                        if (options.showCount) {
                            thisAlpine.$refs.current.innerHTML = (sw.activeIndex + 1)
                            thisAlpine.$refs.total.innerHTML = sw.slides.length
                        }
                    },
                },
            })
            // })
        }
    }
}
window.obaia.Components.menu = function (e = {
    open: !1
}) {
    return {
        init() {
            this.items = Array.from(this.$el.querySelectorAll('[role="menuitem"]')),
                this.$watch("open", (() => {
                        this.open && (this.activeIndex = -1)
                    }
                ))
        },
        activeDescendant: null,
        activeIndex: null,
        items: null,
        open: e.open,
        focusButton() {
            this.$refs.button.focus()
        },
        onButtonClick() {
            this.open = !this.open,
            this.open && this.$nextTick((() => {
                    this.$refs["menu-items"].focus()
                }
            ))
        },
        onButtonEnter() {
            this.open = !this.open,
            this.open && (this.activeIndex = 0,
                this.activeDescendant = this.items[this.activeIndex].id,
                this.$nextTick((() => {
                        this.$refs["menu-items"].focus()
                    }
                )))
        },
        onArrowUp() {
            if (!this.open)
                return this.open = !0,
                    this.activeIndex = this.items.length - 1,
                    void (this.activeDescendant = this.items[this.activeIndex].id);
            0 !== this.activeIndex && (this.activeIndex = -1 === this.activeIndex ? this.items.length - 1 : this.activeIndex - 1,
                this.activeDescendant = this.items[this.activeIndex].id)
        },
        onArrowDown() {
            if (!this.open)
                return this.open = !0,
                    this.activeIndex = 0,
                    void (this.activeDescendant = this.items[this.activeIndex].id);
            this.activeIndex !== this.items.length - 1 && (this.activeIndex = this.activeIndex + 1,
                this.activeDescendant = this.items[this.activeIndex].id)
        },
        onClickAway(e) {
            if (this.open) {
                const t = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e => `${e}:not([tabindex='-1'])`)).join(",");
                this.open = !1,
                e.target.closest(t) || this.focusButton()
            }
        }
    }
}

window.obaia.Components.popoverGroup = function () {
    return {
        __type: "popoverGroup",
        init() {
            let e = t => {
                    document.body.contains(this.$el) ? t.target instanceof Element && !this.$el.contains(t.target) && window.dispatchEvent(new CustomEvent("close-popover-group", {
                        detail: this.$el
                    })) : window.removeEventListener("focus", e, !0)
                }
            ;
            window.addEventListener("focus", e, !0)
        }
    }
}

window.obaia.Components.popover = function ({open: e = !1, focus: t = !1} = {}) {
    const i = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e => `${e}:not([tabindex='-1'])`)).join(",");
    return {
        __type: "popover",
        open: e,
        init() {
            t && this.$watch("open", (e => {
                    e && this.$nextTick((() => {
                            !function (e) {
                                const t = Array.from(e.querySelectorAll(i));
                                !function e(i) {
                                    void 0 !== i && (i.focus({
                                        preventScroll: !0
                                    }),
                                    document.activeElement !== i && e(t[t.indexOf(i) + 1]))
                                }(t[0])
                            }(this.$refs.panel)
                        }
                    ))
                }
            ));
            let e = i => {
                    if (!document.body.contains(this.$el))
                        return void window.removeEventListener("focus", e, !0);
                    let n = t ? this.$refs.panel : this.$el;
                    if (this.open && i.target instanceof Element && !n.contains(i.target)) {
                        let e = this.$el;
                        for (; e.parentNode;)
                            if (e = e.parentNode,
                            e.__x instanceof this.constructor) {
                                if ("popoverGroup" === e.__x.$data.__type)
                                    return;
                                if ("popover" === e.__x.$data.__type)
                                    break
                            }
                        this.open = !1
                    }
                }
            ;
            window.addEventListener("focus", e, !0)
        },
        onEscape() {
            this.open = !1,
            this.restoreEl && this.restoreEl.focus()
        },
        onClosePopoverGroup(e) {
            e.detail.contains(this.$el) && (this.open = !1)
        },
        toggle(e) {
            this.open = !this.open,
                this.open ? this.restoreEl = e.currentTarget : this.restoreEl && this.restoreEl.focus()
        }
    }
}

window.obaia.Components.radioGroup = function ({initialCheckedIndex: e = 0} = {}) {
    return {
        value: void 0,
        active: void 0,
        init() {
            let t = Array.from(this.$el.querySelectorAll("input"));
            this.value = t[e]?.value;
            for (let e of t)
                e.addEventListener("change", (() => {
                        console.log(e.value);
                        this.active = e.value
                    }
                )),
                    e.addEventListener("focus", (() => {
                            this.active = e.value
                        }
                    ));
            window.addEventListener("focus", (() => {
                    console.log("Focus change"),
                    t.includes(document.activeElement) || (console.log("HIT"), this.active = void 0
                    )
                }
            ), !0)
        }
    }
}
